<template>
  <div>
    <v-col v-for="item in places" :key="item.place_id" cols="12">
      <place-card :activePlace="item" />
    </v-col>
  </div>
</template>

<script>
import Place from '@/components/Place.vue';
import { mapState } from "vuex";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  props: ['list'],
  data: () => ({
    places: [],
  }),
  components: {
    'place-card': Place
    },
  methods: {
    ...mapActions(['searchPlaceDetails']),
  },
  computed: {
  },
  watch: {
    list() {
      if (this.list && this.list.length) {
        var results = []
        _.forEach(this.list, r=>{
          this.searchPlaceDetails({
            place_id: r.get('place_id'), 
            objectId: r.id,
            notes: r.get('notes'),
            like: r.get('like'),
            }).then(p=>{results.push(p)})
        })
        this.places = results;
      } else {
        this.places = []
      }
    }
  }
};
</script>
